/**** mgt.ControllerCard */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'ControllerCard',
  title: 'Служебные карты контролёра',
  apiType: apiTypes.DEFAULT,
  connections: {
    driver: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Driver',
      index: 'driver_id',
      fields: ['last_name', 'first_name', 'middle_name'],
      format: (elem: any) =>
        `${elem['last_name'] || ''} ${elem['first_name'] || ''} ${elem[
        'middle_name'
        ] || ''}`,
      autocomplete: true,
    }
  },
  elemsOnPage: 100,
  fields: [
    {
      name: 'card_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'card_number',
      title: 'Номер ССК',
      type: 'text',
      required: true
    },
    {
      name: 'worker_id',
      title: 'Сотрудник',
      type: 'number',
      required: false,
      connection: 'driver'
    }
  ],
  newTemplate: {
    card_id:null,
    card_number:'',
    worker_id:null
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'card_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'card_id',
        field: 'card_id',
      },{
        title: 'card_number',
        field: 'card_number',
      },{
        title: 'worker_id',
        field: 'worker_id',
      }
    ],
    example: `1;111;1`,
  }
};

export default config;